module.exports = __webpack_public_path__ + "img/sleeve cap yoke.c64384ef.png";